import { type ReactElement } from 'react';
import styles from './donation-table-rules.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { MyTable } from '@utmb/design-system/my-table/MyTable';
import { MyTableCell } from '@utmb/design-system/my-table/MyTableCell';
import { MyTableHeader } from '@utmb/design-system/my-table/MyTableHeader';
import { MyTableRow } from '@utmb/design-system/my-table/MyTableRow';
import LoyaltyActionRuleView from '@utmb/types/view/LoyaltyActionRuleView';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import { useTranslation } from 'next-i18next';

export interface DonationTableRulesProps {
    rules: LoyaltyActionRuleView[];
}

export function DonationTableRules({ rules }: DonationTableRulesProps): ReactElement | null {
    const { t } = useTranslation('myutmb');
    return (
        <div className={styles.raceTableRules}>
            <MyTable className={styles.table}>
                <MyTableHeader className={styles.table_header}>
                    <MyTableCell column={1}>
                        <></>
                    </MyTableCell>
                    <MyTableCell hiddenOnMobile column={2}>
                        <Font.OxaniumRegular className={styles.headerText} mobile="13" desktop="15">
                            {t('myUtmb.howToGainPoints.donate.DONATE_LEVEL1')}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell hiddenOnMobile column={2}>
                        <Font.OxaniumRegular className={styles.headerText} mobile="13" desktop="15">
                            {t('myUtmb.howToGainPoints.donate.DONATE_LEVEL2')}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell hiddenOnMobile column={2}>
                        <Font.OxaniumRegular className={styles.headerText} mobile="13" desktop="15">
                            {t('myUtmb.howToGainPoints.donate.DONATE_LEVEL3')}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                </MyTableHeader>

                <MyTableRow className={styles.customTableRow}>
                    <MyTableCell className={styles.legendCell} column={1}>
                        <Icon variant={IconsEnum.MY_UTMB_POINTS_GENERIC} width={54} height={54} />
                    </MyTableCell>
                    <MyTableCell label={`${rules[0].type}`} hiddenOnMobile column={2}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {rules[0].points}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={`${rules[1].type}`} hiddenOnMobile column={2}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {rules[1].points}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                    <MyTableCell label={`${rules[2].type}`} hiddenOnMobile column={2}>
                        <Font.OxaniumRegular mobile="13" desktop="15">
                            {rules[2].points}
                        </Font.OxaniumRegular>
                    </MyTableCell>
                </MyTableRow>
            </MyTable>
        </div>
    );
}
